import { ICellRendererParams } from "ag-grid-community";
import { gridCellStyles } from "~/pages/Compliance/Common/GridCellBackgrounds/styles_vanilla.css";
import { BeneficiaryDetails, PaymentBeneficiary } from "../../types";
import { AddBeneficiary } from "./AddBeneficiary";
import { BeneficiaryView } from "./BeneficiaryView";

export const BeneficiaryCellRenderer = (params: ICellRendererParams<BeneficiaryDetails>) => {
  const { paymentBeneficiary } = params.data ?? {
    paymentBeneficiary: undefined,
    paymentPrefId: undefined,
  };

  return (
    <>
      {paymentBeneficiary ? (
        <BeneficiaryView paymentBeneficiary={paymentBeneficiary} />
      ) : (
        <AddBeneficiary />
      )}
    </>
  );
};

export const getBeneficiaryCellStyle = (
  paymentBeneficiary?: PaymentBeneficiary | null,
  readonly?: boolean,
) => {
  if (paymentBeneficiary) {
    return gridCellStyles.default;
  }

  return readonly ? gridCellStyles.neutral : gridCellStyles.primary;
};
